import { render } from "./Admin.Finance.vue?vue&type=template&id=c7a36d20"
import script from "./Admin.Finance.vue?vue&type=script&lang=js"
export * from "./Admin.Finance.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__